<template>
  <div class="content-header">
    <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="item in data" :key="item.path" :to="{ path: item.path}"><span class="content-item">{{ item.text }}</span></el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'ContentHeader',
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
    }
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.content-header
  padding-top: 15px
  padding-bottom: 15px
  padding-left: 20px
  border-bottom: 1px solid #e6e6e6
  background-color: #fff
  .el-breadcrumb
    font-size: 16px
    .content-item
      color: #409EFF

</style>



// WEBPACK FOOTER //
// src/components/ContentHeader.vue